import { store } from '../store'
import DynamicModuleRegistrationUtil from '../utils/dynamicModuleRegistration'
import giftNotesSignup from '@/enums/modules/routes/giftNotesSignup'

const GiftNotesSignupStoreModule = () =>
  import('../store/modules/giftNotesSignup')

const GiftNotesSignup = () =>
  import('@/components/giftNotesSignup/GiftNotesSignup')

const dynamicModuleRegistrationGiftNotesSignupArgs = () => {
  return {
    modulesNamespace: store._modulesNamespaceMap,
    moduleName: 'GiftNotesSignup',
    module: GiftNotesSignupStoreModule,
    store,
    modulePath: 'GiftNotesSignup'
  }
}

export default [
  {
    path: '/giftnotes/signup',
    name: giftNotesSignup.GiftNotesSignup,
    component: GiftNotesSignup,
    beforeEnter (_to, _from, next) {
      DynamicModuleRegistrationUtil(
        dynamicModuleRegistrationGiftNotesSignupArgs()
      ).then(() => next())
    },
    meta: { showSideNav: true }
  }
]
